module.exports = __webpack_public_path__ + "img/upper_ruffle_length.244c7f37.png";